import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  display: flex;
  gap: 15px;
  align-items: center;
  padding-left: 5px;
  width: 100%;
`;

export default Wrapper;
